import { ConfirmDialog } from '@/shared/ui/components'
import type { ProUpgradeConfirmView } from '../hooks/use-pro-paywall-page'

export type ProUpgradeConfirmDialogProps = {
  confirm: ProUpgradeConfirmView
  onConfirm: () => void
  onCancel: () => void
}

export function ProUpgradeConfirmDialog({
  confirm,
  onConfirm,
  onCancel,
}: ProUpgradeConfirmDialogProps) {
  return (
    <ConfirmDialog
      open={confirm.isOpen}
      title={confirm.title}
      description={confirm.description}
      confirmLabel={confirm.confirmLabel}
      cancelLabel="Not now"
      onConfirm={onConfirm}
      onCancel={onCancel}
      isBusy={confirm.isBusy}
      errorMessage={confirm.errorMessage === '' ? null : confirm.errorMessage}
    >
      <ul data-testid="pro-upgrade-confirm-details" className="flex flex-col gap-1 text-sm">
        {confirm.details.map((detail) => (
          <li key={detail} className="text-muted-foreground">
            {detail}
          </li>
        ))}
      </ul>
    </ConfirmDialog>
  )
}
